/* eslint-disable no-undef */
/* eslint-disable eqeqeq */
import ThailandAutoComplete from 'vue-thailand-address-autocomplete'
import apiCus from '../../../services/service_customer'
import apipos from '../../../services/service_pos'
import Swal from 'sweetalert2'
import VueBootstrapTypeahead from 'vue-bootstrap-typeahead'

export default {
  props: ['host'],
  components: {
    ThailandAutoComplete,
    VueBootstrapTypeahead
  },
  data () {
    return {
      search: '',
      currentPage: 1,
      addTab: 0,
      items_perpage: 10,
      modal_active: false,
      modal_data: {
        code: '',
        name: '',
        credit_day: 0,
        debt_limit: 0,
        debt_balance: 0,
        telephone: '',
        address: '',
        sub_district: '',
        district: '',
        province: '',
        post_code: '',
        active_status: 1
      },
      modal_title: '',
      data_list: [],
      header: {
        headers: {
          'Access-Token': sessionStorage.token
        }
      },
      receive_item: {
        'id': 0,
        'company_id': 1,
        'branch_id': 1,
        'doc_no': '',
        'tax_type': 1,
        'tax_rate': 7,
        'doc_date': '',
        'ar_id': 0,
        'ar_code': '',
        'ar_name': '',
        'credit_day': 0,
        'due_date': '',
        'return_type': '',
        'item_amount': 0,
        'old_amount': 0,
        'true_amount': 0,
        'discount_word': '',
        'discount_amount': 0,
        'before_tax_amount': 0,
        'tax_amount': 0,
        'total_amount': 0,
        'return_status': 0,
        'cash_amount': 0,
        'credit_amount': 0,
        'chq_amount': 0,
        'bank_amount': 0,
        'promt_pay_amount': 0,
        'bill_balance': 0,
        'ref_no': '',
        'cause_type': '',
        'description': '',
        'is_cancel': 0,
        'create_by': '',
        'create_time': '',
        'edit_by': '',
        'edit_time': '',
        'cancel_by': '',
        'cancel_time': '',
        'subs': []
      },
      data_list_pos: [],
      currentPage1: 1,
      items_perpage1: 10,
      search_pos: '',
      data_list_cus: [],
      form_data: '',
      query: '',
      customer: ''
    }
  },
  watch: {
    // When the query value changes, fetch new results from
    // the API - in practice this action should be debounced
    query (newQuery) {
      clearTimeout(this.timeout)
      const self = this
      this.timeout = setTimeout(function () {
        self.getCusAll(newQuery)
      }, 200)
    }
  },
  filters: {
    stringify (value) {
      return JSON.stringify(value, null, 2)
    }
  },
  computed: {
    filterData: function () {
      let text = this.search.trim()
      return this.data_list.filter(receiveList => {
        return (
          receiveList.doc_no.indexOf(text) > -1
        )
      })
    },
    paginate: function () {
      this.totalItem = this.filterData.length
      if (this.currentPage >= this.totalPages) {
        this.currentPage = Math.max(0, this.totalPages - 1)
      }
      var index = (this.currentPage - 1) * this.items_perpage
      return this.filterData.slice(index, index + this.items_perpage)
    },
    filterData1: function () {
      let text = this.search_pos.trim()
      return this.data_list_pos.filter(posList => {
        return (
          posList.doc_no.indexOf(text) > -1
        )
      })
    },
    paginate1: function () {
      this.totalItem1 = this.filterData1.length
      if (this.currentPage1 >= this.totalPages) {
        this.currentPage1 = Math.max(0, this.totalPages - 1)
      }
      var index = (this.currentPage1 - 1) * this.items_perpage1
      return this.filterData1.slice(index, index + this.items_perpage1)
    }
  },
  methods: {
    handleChange (value) {
      console.log(`selected ${value}`)
    },
    SelectChange (value) {
      console.log(JSON.stringify(value))
      this.receive_item.ar_code = value.code
      this.receive_item.ar_name = value.name
      this.receive_item.ar_id = value.id
      this.customer = this.receive_item.ar_code + ':' + this.receive_item.ar_name
      // const ar = value.split(':')
      // if (ar.length > 1) {
      //   this.receive_item.ar_code = value = ar[0]
      // }
      // this.receive_item.ar_code = ar[0]
      // this.receive_item.ar_name = ar[1]
    },
    clearChange () {
      this.customer = ''
      this.receive_item.ar_id = 0
      this.receive_item.ar_code = ''
      this.receive_item.ar_name = ''
    },
    filterOption (input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      )
    },
    itemRender (current, type, originalElement) {
      if (type === 'prev') {
        return 'Previous'
      } else if (type === 'next') {
        return 'Next'
      }
      return originalElement
    },
    onChange (pageNumber) {
      this.currentPage = pageNumber
    },
    onChange1 (pageNumber) {
      this.currentPage1 = pageNumber
    },
    select (address) {
      this.modal_data.sub_district = address.district
      this.modal_data.district = address.amphoe
      this.modal_data.province = address.province
      this.modal_data.post_code = address.zipcode
    },
    editCus (data) {
      this.modal_title = 'แก้ไขข้อมูลลูกหนี้'
      this.modal_active = true
      this.modal_data = data
    },
    close_modal () {
      this.modal_active = false
      this.modal_data = {
        id: 0,
        code: '',
        name: '',
        credit_day: 0,
        debt_limit: 0,
        debt_balance: 0,
        telephone: '',
        address: '',
        sub_district: '',
        district: '',
        province: '',
        post_code: '',
        active_status: 1
      }
    },
    newReceive () {
      this.receive_item = {
        'id': 0,
        'company_id': 1,
        'branch_id': 1,
        'doc_no': '',
        'tax_type': 1,
        'tax_rate': 7,
        'doc_date': '',
        'ar_id': 0,
        'ar_code': '',
        'ar_name': '',
        'credit_day': 0,
        'due_date': '',
        'return_type': '',
        'item_amount': 0,
        'old_amount': 0,
        'true_amount': 0,
        'discount_word': '',
        'discount_amount': 0,
        'before_tax_amount': 0,
        'tax_amount': 0,
        'total_amount': 0,
        'return_status': 0,
        'cash_amount': 0,
        'credit_amount': 0,
        'chq_amount': 0,
        'bank_amount': 0,
        'promt_pay_amount': 0,
        'bill_balance': 0,
        'ref_no': '',
        'cause_type': '',
        'description': '',
        'subs': [],
        'testdata': null
      }
      this.addTab = 1
    },
    getCusAll (val) {
      let body = {
        keyword: val,
        limit: 500,
        status: 1
      }
      apiCus.listAll(
        this.REST_URL,
        this.header,
        body,
        result => {
          if (result.response === 'success') {
            this.data_list_cus = result.data
            // this.data_list_cus = []
            // result.data.forEach(val => {
            //   this.data_list_cus.push(
            //     val['code'] + ': ' + val['name']
            //   )
            //   if (this.receive_item.ar_code != '') {
            //     this.customer = this.receive_item.ar_code + ': ' + this.receive_item.name
            //     if (this.$refs.cusAutoSearch) {
            //       this.$refs.cusAutoSearch.inputValue = this.customer
            //     }
            //   } else {
            //     this.customer = ''
            //     if (this.$refs.cusAutoSearch) {
            //       this.$refs.cusAutoSearch.inputValue = ''
            //     }
            //   }
            // })
          } else {
            this.$notification['warning']({
              message: 'ดึงข้อมูลลูกหนี้',
              description: result.message
            })
          }
        },
        error => {
          alert('ไม่สามารถเข้าถึงข้อมูล ' + JSON.stringify(error))
        }
      )
    },
    // getCusAll () {
    //   this.$store.commit('Loading')
    //   let body = {
    //     'keyword': '',
    //     'limit': 1000,
    //     'status': 1
    //   }
    //   apiCus.listAll(this.REST_URL,
    //     this.header,
    //     body,
    //     result => {
    //       if (result.response === 'success') {
    //         this.data_list_cus = result.data
    //       } else {
    //         this.$notification['warning']({
    //           message: 'ดึงข้อมูลลูกหนี้',
    //           description:
    //             result.message
    //         })
    //       }
    //       this.$store.commit('Loading')
    //     },
    //     error => {
    //       alert('ไม่สามารถเข้าถึงข้อมูล ' + JSON.stringify(error))
    //       this.$store.commit('Loading')
    //     }
    //   )
    // },
    getAll () {
      this.$store.commit('Loading')
      let body = {
        'keyword': ''
      }
      apipos.receiveList(this.REST_URL,
        body,
        this.header,
        result => {
          // console.log(result)
          if (result.response === 'success') {
            this.data_list = result.data
          } else {
            this.$notification['warning']({
              message: 'ดึงข้อมูลลูกหนี้',
              description:
                result.message
            })
          }
          this.$store.commit('Loading')
        },
        error => {
          alert('ไม่สามารถเข้าถึงข้อมูล ' + JSON.stringify(error))
          this.$store.commit('Loading')
        }
      )
    },
    removeBill (val) {
      Swal.fire({
        title: 'ยกเลิกรายการรับคืนสินค้า',
        text: 'ท่านต้องการลบข้อมูล ' + val + ' ใช่หรือไม่ ?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        reverseButtons: true
      }).then((result) => {
        if (result.value) {
          this.$store.commit('Loading')
          var body = {
            'doc_no': val
          }
          apipos.receiveCancel(this.REST_URL,
            body,
            this.header,
            result => {
              if (result.response === 'success') {
                this.getAll()
                this.$notification['success']({
                  message: 'ลบข้อมูลเอกสาร' + val + 'สำเร็จ',
                  description:
                    result.message
                })
              } else {
                this.$notification['error']({
                  message: 'ลบข้อมูลเอกสาร' + val + 'ไม่สำเร็จ',
                  description:
                    result.message
                })
              }
              this.$store.commit('Loading')
            },
            error => {
              alert('ระบบมีปัญหา ' + JSON.stringify(error))
              this.$store.commit('Loading')
            }
          )
        }
      })
    },
    getEdit (val) {
      this.$store.commit('Loading')
      var body = {
        'id': val
      }
      apipos.receiveById(this.REST_URL,
        body,
        this.header,
        result => {
          if (result.response === 'success') {
            this.receive_item = result.data
            this.customer = this.receive_item.ar_code + ':' + this.receive_item.ar_name
            this.addTab = 1
            this.calAmount()
          } else {
            this.$notification['error']({
              message: 'ดึงเอกสารไม่สำเร็จ',
              description:
                result.message
            })
          }
          this.$store.commit('Loading')
        },
        error => {
          alert('ระบบมีปัญหา ' + JSON.stringify(error))
          this.$store.commit('Loading')
        }
      )
    },
    ConfirmBill () {
      if (this.receive_item.doc_no) {
        this.editBill()
      } else {
        this.addBill()
      }
    },
    addBill () {
      this.$store.commit('Loading')
      // this.modal_data.credit_day = parseInt(this.modal_data.credit_day)
      this.receive_item.shift_id = parseInt(this.host.id)
      console.log(JSON.stringify(this.receive_item))
      apipos.receiveNew(this.REST_URL,
        this.receive_item,
        this.header,
        result => {
          if (result.response === 'success') {
            this.getAll()
            this.$notification['success']({
              message: 'บันทึกสำเร็จ'
            })
            this.addTab = 0
            $('#ToolModal').modal('hide')
            $('body').on('hidden.bs.modal', '.modal', function () {
              $(this).removeData('bs.modal')
            })
          } else {
            this.$notification['warning']({
              message: 'แจ้งปัญหา',
              description: result.message
            })
          }
          this.$store.commit('Loading')
          this.close_modal()
        },
        error => {
          alert('ระบบมีปัญหา ' + JSON.stringify(error))
          this.$store.commit('Loading')
        }
      )
    },
    editBill () {
      this.$store.commit('Loading')
      // this.modal_data.credit_day = parseInt(this.modal_data.credit_day)
      this.receive_item.doc_date = this.receive_item.doc_date.substr(0, 10)
      console.log(JSON.stringify(this.receive_item))
      apipos.receiveUpdate(this.REST_URL,
        this.receive_item,
        this.header,
        result => {
          if (result.response === 'success') {
            this.getAll()
            this.$notification['success']({
              message: 'บันทึกสำเร็จ'
            })
            this.addTab = 0
            $('#ToolModal').modal('hide')
            $('body').on('hidden.bs.modal', '.modal', function () {
              $(this).removeData('bs.modal')
            })
          } else {
            this.$notification['warning']({
              message: 'แจ้งปัญหา',
              description: result.message
            })
          }
          this.$store.commit('Loading')
          this.close_modal()
        },
        error => {
          alert('ระบบมีปัญหา ' + JSON.stringify(error))
          this.$store.commit('Loading')
        }
      )
    },
    calAmount () {
      let totalSub = 0
      for (let i = 0; i < this.receive_item.subs.length; i++) {
        this.receive_item.subs[i].amount = this.receive_item.subs[i].disc_qty * this.receive_item.subs[i].price
        // console.log(this.receive_item.subs[i].amount)
        totalSub += parseFloat(this.receive_item.subs[i].amount)
      }
      this.receive_item.item_amount = totalSub
      this.receive_item.total_amount = totalSub + this.receive_item.cash_amount
      this.receive_item.true_amount = totalSub + this.receive_item.cash_amount
      this.receive_item.bill_balance = this.receive_item.old_amount - this.receive_item.true_amount
      this.receive_item.before_tax_amount = this.receive_item.true_amount - (this.receive_item.true_amount * 0.07)
      this.receive_item.tax_amount = (this.receive_item.true_amount * 0.07)
    },
    getSaleList () {
      if (this.receive_item.ar_code == '') {
        this.$notification['warning']({
          message: 'กรุณาเลือกลูกค้า'
        })
        return
      }
      this.$store.commit('Loading')
      let body = {
        'ar_code': this.receive_item.ar_code,
        'keyword': '',
        'limit': 100
      }
      apipos.getPosList(this.REST_URL,
        body,
        this.header,
        result => {
          // console.log(result)
          if (result.response === 'success') {
            this.data_list_pos = result.data
            this.addTab = 2
          } else {
            this.$notification['warning']({
              message: 'ดึงข้อมูลบิลขายไม่ได้',
              description:
                result.message
            })
          }
          this.$store.commit('Loading')
        },
        error => {
          alert('ดึงข้อมูลบิลขายไม่ได้ ' + JSON.stringify(error))
          this.$store.commit('Loading')
        }
      )
    },
    getPos (val) {
      this.receive_item.company_id = val.company_id
      this.receive_item.branch_id = val.branch_id
      this.receive_item.tax_type = val.tax_type
      this.receive_item.tax_rate = val.tax_rate
      this.receive_item.ar_code = val.ar_code
      this.receive_item.ar_name = val.ar_name
      this.receive_item.credit_day = 0
      this.receive_item.return_type = 'ลดหนี้สินค้า'
      this.receive_item.item_amount = 0
      this.receive_item.old_amount = val.total_amount
      this.receive_item.true_amount = 0
      this.receive_item.before_tax_amount = 0
      this.receive_item.tax_amount = 0
      this.receive_item.total_amount = 0
      this.receive_item.return_status = 1
      this.receive_item.cash_amount = 0
      this.receive_item.credit_amount = 0
      this.receive_item.chq_amount = 0
      this.receive_item.bank_amount = 0
      this.receive_item.promt_pay_amount = 0
      this.receive_item.bill_balance = val.total_amount
      this.receive_item.ref_no = val.doc_no
      this.receive_item.cause_type = ''
      this.receive_item.description = ''
      this.receive_item.subs = val.sub
      for (let i = 0; i < val.sub.length; i++) {
        this.receive_item.subs[i].item_id = val.sub[i].item_id
        this.receive_item.subs[i].item_code = val.sub[i].item_code
        this.receive_item.subs[i].item_name = val.sub[i].item_name
        this.receive_item.subs[i].description = val.sub[i].description
        this.receive_item.subs[i].wh_id = val.sub[i].wh_id
        this.receive_item.subs[i].wh_code = val.sub[i].wh_code
        this.receive_item.subs[i].shelf_id = val.sub[i].shelf_id
        this.receive_item.subs[i].shelf_code = val.sub[i].shelf_code
        this.receive_item.subs[i].price = val.sub[i].price
        this.receive_item.subs[i].disc_qty = 0
        this.receive_item.subs[i].unit_id = val.sub[i].unit_id
        this.receive_item.subs[i].unit_code = val.sub[i].unit_code
        this.receive_item.subs[i].amount = 0
        this.receive_item.subs[i].ref_line_number = 0
        this.receive_item.subs[i].line_number = val.sub[i].line_number
        this.receive_item.subs[i].ref_line_number = val.sub[i].ref_line_number
      }
      // orther
      this.receive_item.doc_no = ''
      this.receive_item.id = 0
      this.addTab = 1
    },
    printBill (data) {
      this.$notification['warning']({
        message: 'แจ้งปัญหา',
        description: 'กำลังปรับปรุง'
      })
      // this.form_data = JSON.stringify(data)
      // setTimeout(() => {
      //   this.$refs.printGetback.submit()
      // }, 1000)
    },
    printPDF (data) {
      this.$store.commit('Loading')
      apipos.receiveById(this.REST_URL,
        { id: data.id },
        this.header,
        result => {
          if (result.response === 'success') {
            this.form_data = JSON.stringify(result.data)
            setTimeout(() => {
              this.$refs.printGetback.submit()
              this.$store.commit('Loading')
              $('#ToolModal').modal('hide')
              $('body').on('hidden.bs.modal', '.modal', function () {
                $(this).removeData('bs.modal')
              })
            }, 1000)
          } else {
            this.$notification['warning']({
              message: 'พิมพ์ใบแจ้งยอดไม่ได้',
              description: result.message
            })
            $('body').on('hidden.bs.modal', '.modal', function () {
              $(this).removeData('bs.modal')
            })
            this.$store.commit('Loading')
          }
        },
        error => {
          $('#ToolModal').modal('show')
          this.$store.commit('Loading')
          alert('ไม่สามารถเข้าถึงข้อมูล ' + JSON.stringify(error))
        })
    },
    checkRemainQTY (id, itemcode, unit, line, newQty, oldQty) {
      let body = {
        'id': id,
        'item_code': itemcode,
        'unit_code': unit,
        'line_number': line
      }
      apipos.checkReturn(this.REST_URL,
        this.header,
        body,
        result => {
          // console.log(result)
          if (result.response === 'success') {
            if ((newQty + oldQty) != result.remain_qty) {
              Swal.fire({
                title: 'เกินจำนวนวคงเหลือ',
                text: 'กรุณากรอกใหม่',
                icon: 'warning',
                showCancelButton: false,
                confirmButtonText: 'รับหราบ'
              })
            } else {
              this.calAmount()
            }
          } else {
            this.$notification['warning']({
              message: 'ดึงข้อมูลลูกหนี้',
              description:
                result.message
            })
          }
        },
        error => {
          alert('ไม่สามารถเข้าถึงข้อมูล ' + JSON.stringify(error))
        }
      )
    }
  },
  mounted () {
    this.checkUser()
    this.getAll()
    this.getCusAll()
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/pos/receive_products.js